import { IPromoter } from '@admin/pages/promoter-manager/interfaces/promoter.interface';
import { PromoterService } from '@admin/pages/promoter-manager/services/promoter.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  Catalog,
  FilterStatus,
  IAuctionFilterDto,
} from '@shared/interfaces/search.interface';
import { LanguageService } from '@shared/services/language.service';
import { MetaManagerService } from '@shared/services/meta-manager.service';
import { SearchService } from '@shared/services/search.service';
import { environment } from 'src/environments/environment';
import { AuctionView } from '../articles-manager/interfaces/auction.interface';

@Component({
  selector: 'app-promoter',
  templateUrl: './promoter.component.html',
  styleUrls: ['./promoter.component.scss'],
  host: { ngSkipHydration: 'true' },
})
@UntilDestroy()
export class PromoterComponent implements OnInit {
  id: number;
  selectedPromoter: IPromoter = {
    idPromoter: -1,
    showAmount: false,
    totalAmount: 0,
    postedFileName: '',
    postedFileBase64: '',
    isEnabled: true,
    photoFullPath: '',
    logoFullPath: '',
    postedLogoName: '',
    postedLogoBase64: '',
    promoterDataList: [
      {
        title: '',
        subTitle: '',
        idLanguage: 1,
      },
      {
        title: '',
        subTitle: '',
        idLanguage: 2,
      },
    ],
  };
  filters: IAuctionFilterDto = {
    idLanguage: this.languageService.userSelectedLanguage.idLanguage,
    searchText: '',
    idAuctionType: -1,
    idDetail: null,
    onlySigned: false,
    idSport: null,
    idCompetition: null,
    idTeam: null,
    onlyNew: false,
    onlyExpiring: false,
    onlyArriving: false,
    onlyBuyNow: false,
    auctionStatus: FilterStatus.All,
    idEntity: null,
    idCampaign: null,
    idPromoter: null,
    idActiveAuction: null,
    idTagList: [],
    catalog: Catalog.All,
    orderBy: 'evidence',
    orderDirection: 'desc',
  };

  memorabidAuctions: Array<AuctionView> = [];
  marketplaceAuctions: Array<AuctionView> = [];

  idAuctionList: Array<number> = [];
  isLoaded: boolean = false;

  constructor(
    private promoterService: PromoterService,
    private searchService: SearchService,
    public languageService: LanguageService,
    private route: ActivatedRoute,
    private router: Router,
    private metaManagerService: MetaManagerService
  ) {
    var langId = this.languageService.userSelectedLanguage.idLanguage;

    this.searchService.setFilters(this.searchService.searchRoute, {
      ...this.filters,
    });

    this.route.params.subscribe((params: Params) => {
      this.id = +params['idPromoter'];

      this.promoterService
        .getByPK(this.id)
        .pipe(untilDestroyed(this))
        .subscribe((dataR) => {
          this.selectedPromoter = dataR;
          if (this.selectedPromoter.idPromoter == -1) {
            this.router.navigate(['home']);
          } else {
            this.selectedPromoter.promoterDataList =
              this.selectedPromoter.promoterDataList.filter(
                (t) => t.idLanguage === langId
              );
          }

          this.filters.idPromoter = this.id;

          this.searchService.setFilters(this.searchService.searchRoute, {
            ...this.filters,
          });

          this.searchService
            .getAllTypes()
            .pipe(untilDestroyed(this))
            .subscribe((dataR) => {
              this.searchService.auctionTypeList = dataR;
              this.search();
            });

          this.metaManagerService.updateTitleAndMeta(
            this.selectedPromoter.promoterDataList.length > 0
              ? this.selectedPromoter.promoterDataList[0].title
              : '',
            this.selectedPromoter.promoterDataList.length > 0
              ? this.selectedPromoter.promoterDataList[0].subTitle
              : '',
            environment.APPOrigin + '/promoter/' + this.id,
            this.selectedPromoter.photoFullPath
          );
        });
    });
  }

  ngOnInit(): void {}

  // FIXME: duplicated code from search-result.component.ts
  search() {
    this.idAuctionList = [];
    if (
      this.searchService.auctionTypeList.length > 2 &&
      this.filters.idPromoter &&
      this.filters.idPromoter > 0
    ) {
      this.filters.idAuctionType = this.searchService.auctionTypeList[1].key;
      this.searchService
        .getAllV2(this.filters)
        .pipe(untilDestroyed(this))
        .subscribe((dataR) => {
          this.filters.idAuctionType =
            this.searchService.auctionTypeList[2].key;
          this.searchService
            .getAllV2(this.filters)
            .pipe(untilDestroyed(this))
            .subscribe((response) => {
              this.memorabidAuctions = dataR;
              for (let i = 0; i < dataR.length; i++) {
                if (!dataR[i].isFinished) {
                  this.idAuctionList.push(this.memorabidAuctions[i].idAuction);
                }
              }
              // this.sortAuctionsPipe.transform(this.memorabidAuctions);
              this.marketplaceAuctions = response;
              for (let x = 0; x < response.length; x++) {
                if (!response[x].isFinished) {
                  this.idAuctionList.push(
                    this.marketplaceAuctions[x].idAuction
                  );
                }
              }
              // this.sortAuctionsPipe.transform(this.marketplaceAuctions);
              this.isLoaded = true;
            });
        });
    }
  }

  onAuctionStatusFilterChanged(data: { auctionStatusFilter: FilterStatus }) {
    this.filters.auctionStatus = data.auctionStatusFilter;

    this.searchService.setFilters(this.searchService.searchRoute, {
      ...this.filters,
    });

    this.search();
  }

  ngOnDestroy() {
    this.metaManagerService.updateTitleAndMeta('', '', '', '');
  }
}
